import Vue from 'vue'
import Router from 'vue-router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'

import FBGroupFeed from '@/components/fb/group/feed'
import FBGroupUserFeed from '@/components/fb/group/ufeed'
import FBGroupStats from '@/components/fb/group/stats'
import FBGroupCrawl from '@/components/fb/group/crawl'

Vue.use(Router)
Vue.use(BootstrapVue)
Vue.use(VueLodash, lodash)
Vue.use(require('vue-moment'));

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/group/:gid/feed',
            component: FBGroupFeed
        },
        {
            path: '/group/:gid/stats',
            component: FBGroupStats
        },
        {
            path: '/group/:gid/crawl',
            component: FBGroupCrawl
        },
        {
            path: '/group/:gid/:uid',
            component: FBGroupUserFeed
        },
        {
            path: '/group/:gid/ofeed',
            component: () => import('@/components/fb/group/ofeed')
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js